import type { AxiosInstance } from 'axios';
import type { LocalizationLanguage } from '@gov-nx/core/app';
import type {
	SearchAllTypesListDto,
	SearchSignpostListDto,
} from '../generated';
import type { Designation } from '../types/designation';
import type { SignpostRequestParams } from './serviceQuery';

export interface SearchAllTypesRequestParams {
	app: string;
	env: string;
	search?: string;
	locale: LocalizationLanguage;
	types?: string[];
	serviceGroups?: number;
	categorySlugs?: string[];
	designations?: Designation;
	externalServiceLink?: string;
}

export const searchQuery = async (
	axiosCmsBaseInstance: AxiosInstance,
	params: SignpostRequestParams
): Promise<SearchSignpostListDto> => {
	const response = await axiosCmsBaseInstance.get<SearchSignpostListDto>(
		'search',
		{ params }
	);

	return response.data;
};

export const searchAllTypesQuery = async (
	axiosCmsBaseInstance: AxiosInstance,
	params: SearchAllTypesRequestParams
): Promise<SearchAllTypesListDto> => {
	const response = await axiosCmsBaseInstance.get<SearchAllTypesListDto>(
		'search-all-types',
		{ params }
	);

	return response.data;
};
